import { render, staticRenderFns } from "./PuestoDependenciaComponent.vue?vue&type=template&id=2c7d525e&scoped=true"
import script from "./PuestoDependenciaComponent.vue?vue&type=script&lang=js"
export * from "./PuestoDependenciaComponent.vue?vue&type=script&lang=js"
import style0 from "./PuestoDependenciaComponent.vue?vue&type=style&index=0&id=2c7d525e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7d525e",
  null
  
)

export default component.exports